<template>
  <el-dialog
			title="新增商品类目"
			:visible.sync="dialogFormVisible"
			width="30%"
      :destroy-on-close="true"
      @close='cancel'
		>
			<el-form :model="addForm">
				<el-form-item label="商品类目">
					<el-input v-model="addForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="商品状态">
					<el-switch
						v-model="addForm.status"
						active-text="上架"
						inactive-text="下架"
						:active-value="1"
						:inactive-value="0"
						active-color="#13ce66"
						inactive-color="#ff4949"
					>
					</el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="sumbitAddRow">确 定</el-button>
			</div>
		</el-dialog>
</template>
<script>
import {addCommodity} from "@/api/market";
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
		...mapGetters(["token", "app_id", "merch_id"]),
	},
  data(){
    return {
      	addForm: {
				name: "",
				status: 1,
			},
    }
  },
  props:{
    dialogFormVisible:{
      type:Boolean,
    }
  },
  methods:{
    	// 将新增的数据添加到表格中
		async sumbitAddRow() {
			try {
				const { name, status } = this.addForm;
				const res = await addCommodity({
					app_id: this.app_id,
					// parent_id: "",
					name,
					// logo: image.id,
					status: status ? 1 : 0,
				});
				console.log(res);
				if (res.code == 200) {
					this.$message({
						message: "添加成功",
						type: "success",
					});
					this.addForm.name = "";
          this.addForm.status = 0;
          this.$emit('add',false)
				} else {
					this.$message({
						message: res.msg,
						type: "warning",
					});
				}
        this.$emit('add',false)
			} catch (error) {
				console.log(error);
			}
    },
    	cancel() {
        this.$emit('add',false)
			// this.dialogFormVisible = false;
			// this.editFormVisible = false;
    },
    // 获取商品类目列表
		// async getCommodityList() {
		// 	try {
		// 		const res = await categoryList({
		// 			page: this.page,
		// 			app_id: this.app_id,
		// 		});
		// 		if (res.code == 200) {
		// 			if (res.data.total_num > 0) {
		// 				this.loading = false;
    //         console.log(res.data);
    //         this.total_num = res.data.total_num
		// 				this.commodityList = res.data.result;
		// 			} else {
		// 				this.loading = false;
		// 			}
		// 		} else {
		// 			this.loading = false;
		// 		}
		// 	} catch (error) {
		// 		console.log(error);
		// 	}
		// },
  }
}
</script>